import React from "react";
import styles from "../../styles/HomePage.module.css"; // ✅ Required import


const testimonials = [
  {
    text: "I sold my car to Cars24 and the process was incredibly smooth. They offered me the best price and the payment was instant. Highly recommended!",
    name: "Rahul Sharma",
    city: "Delhi",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    text: "Bought my first car from Cars24 and the experience was fantastic. The car was in perfect condition and the warranty gives me peace of mind.",
    name: "Priya Patel",
    city: "Mumbai",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    text: "The financing options made it so easy to buy my dream car. The entire process was transparent and hassle-free. Will definitely buy from them again.",
    name: "Vikram Singh",
    city: "Bangalore",
    img: "https://randomuser.me/api/portraits/men/67.jpg",
  },
];

const Testimonials = () => {
  return (
    <section className={styles.testimonials}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>What Our Customers Say</h2>
        <div className={styles.testimonialGrid}>
          {testimonials.map((t, idx) => (
            <div key={idx} className={styles.testimonialCard}>
              <p className={styles.testimonialText}>"{t.text}"</p>
              <div className={styles.testimonialAuthor}>
                <div className={styles.authorImg}>
                  <img src={t.img} alt={t.name} />
                </div>
                <div className={styles.authorInfo}>
                  <h4>{t.name}</h4>
                  <p>{t.city}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
